// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:49:40

export default {
  "id": "smash-the-bottle",
  "slug": "smash-the-bottle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cc3a1244b9a043959ce0377e5634680e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cc3a1244b9a043959ce0377e5634680e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Smash The Bottle",
      "description": "The goal of the game is simple: break all the bottles on the screen according to the given requests in each stage. Your accuracy and timing are crucial, so pay close attention to the instructions and let the smashing begin!",
      "instructions": "Click on the bottles to destroy them.",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "打破瓶子",
      "description": "游戏目标简单：根据每个阶段的给定要求，打破屏幕上的所有瓶子。精确度和时机至关重要，所以请仔细阅读说明，开始打破吧！",
      "instructions": "点击瓶子以摧毁它们。",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "打破瓶子",
      "description": "遊戲的目標簡單：根據每個階段的指定要求，打破螢幕上所有的瓶子。您的準確度和時間掌握至關重要，所以請密切注意指示，讓打破的遊戲開始吧！",
      "instructions": "點擊瓶子來破壞它們。",
      "genres": [
        "輕鬆型",
        "射擊類"
      ],
      "tags": [
        "時間殺手"
      ]
    },
    "zh-HK": {
      "title": "打破酒瓶",
      "description": "遊戲目標簡單：根據每個階段的指定要求，將螢幕上的所有瓶瓶打碎。準度和時間非常重要，所以請留心指導並開始破瓶吧！",
      "instructions": "點擊瓶子以破壞它們。",
      "genres": [
        "隨意射擊遊戲"
      ],
      "tags": [
        "時間殺手"
      ]
    },
    "ja": {
      "title": "ボトルを壊せ",
      "description": "ゲームの目的はシンプルです：各ステージで与えられた要請に従ってスクリーン上の全てのボトルを割ることです。精度とタイミングが非常に重要ですので、指示に注意を払い、割り始めてください！",
      "instructions": "ボトルをクリックして破壊してください。",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "병을 깨자",
      "description": "게임의 목표는 간단합니다: 각 단계별로 주어진 요청에 따라 화면에 있는 모든 병을 깨세요. 정확도와 시간은 중요합니다, 따라서 지시에 주의하며 깨기에 들어가세요!",
      "instructions": "병을 클릭하여 파괴하세요.",
      "genres": [
        "캐주얼",
        "쏘터"
      ],
      "tags": [
        "시간소모자"
      ]
    },
    "fr": {
      "title": "Casse la Bouteille",
      "description": "L'objectif du jeu est simple : brisez toutes les bouteilles sur l'écran selon les demandes données à chaque étape. Votre précision et votre timing sont cruciaux, donc faites attention aux instructions et lancez-vous dans l'écrasement !",
      "instructions": "Cliquez sur les bouteilles pour les détruire.",
      "genres": [
        "Casual",
        "Tirs"
      ],
      "tags": [
        "Tueur de temps"
      ]
    }
  }
};
